import React from 'react';
import { getMissingProfileFields } from '../utils/profileCompletion';

function ProfileCompletionBanner({ user }) {
  if (!user) return null;

  const missingFields = getMissingProfileFields(user);
  
  if (missingFields.length === 0) return null;

  return (
    <div className="fixed top-[85px] sm:top-[120px] left-0 right-0 z-40 px-3 sm:px-6 lg:px-8 animate-fade-in">
      <div className="max-w-7xl mx-auto bg-gradient-to-r from-red-50 via-orange-50 to-red-50 border-2 border-red-400 rounded-xl p-3 sm:p-4 shadow-lg">
        <div className="flex items-start gap-3 sm:gap-4">
          <div className="flex-shrink-0 mt-0.5">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red-500 rounded-full flex items-center justify-center animate-pulse">
              <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-base sm:text-lg font-bold text-red-900 mb-2">
              Complete Your Profile to Continue
            </h3>
            <p className="text-sm sm:text-base text-red-800 mb-3">
              Please provide the following information to complete your account setup:
            </p>
            <div className="bg-white/60 rounded-lg p-3 sm:p-4 border border-red-200">
              <ul className="space-y-2">
                {missingFields.map((field, index) => (
                  <li key={index} className="flex items-center gap-2 text-sm sm:text-base text-red-900">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-red-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    <span className="font-semibold">{field}</span>
                  </li>
                ))}
              </ul>
            </div>
            <p className="mt-3 text-xs sm:text-sm text-red-700 font-medium">
              ⚠️ You cannot access other features until your profile is complete.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileCompletionBanner;
